
import { EventStatistics } from "../lib/types";

// Lokális, fejlesztési statisztikák tárolására szolgáló objektum
// Valós implementációban ez adatbázisban lenne tárolva
const statisticsStore: Record<string, EventStatistics> = {};

// Esemény megtekintés helyi rögzítése (fejlesztési környezetben)
export const recordLocalEventView = (eventId: string): void => {
  if (!statisticsStore[eventId]) {
    initializeEventStatistics(eventId);
  }

  statisticsStore[eventId].viewCount += 1;
  statisticsStore[eventId].lastUpdated = new Date().toISOString();
  updateClickThroughRate(eventId);

  console.log(`Local view recorded for event ${eventId}. Total views: ${statisticsStore[eventId].viewCount}`);
};

// Eseményre kattintás helyi rögzítése (fejlesztési környezetben)
export const recordLocalEventClick = (eventId: string): void => {
  if (!statisticsStore[eventId]) {
    initializeEventStatistics(eventId);
  }

  statisticsStore[eventId].clickCount += 1;
  statisticsStore[eventId].lastUpdated = new Date().toISOString();
  updateClickThroughRate(eventId);

  console.log(`Local click recorded for event ${eventId}. Total clicks: ${statisticsStore[eventId].clickCount}`);
};

// Esemény statisztikák helyi lekérése (fejlesztési környezetben)
export const getLocalEventStatistics = (eventId: string): EventStatistics => {
  if (!statisticsStore[eventId]) {
    initializeEventStatistics(eventId);
  }

  return { ...statisticsStore[eventId] };
};

// Segédfüggvények

// Statisztikák inicializálása
const initializeEventStatistics = (eventId: string): void => {
  statisticsStore[eventId] = {
    eventId,
    eventCode: eventId, // Egyszerűsítés, valós környezetben az API-tól jönne
    viewCount: 0,
    clickCount: 0,
    clickThroughRate: 0,
    lastUpdated: new Date().toISOString(),
  };
};

// Átkattintási arány számítása és frissítése
const updateClickThroughRate = (eventId: string): void => {
  const stats = statisticsStore[eventId];

  if (stats.viewCount > 0) {
    stats.clickThroughRate = Math.round((stats.clickCount / stats.viewCount) * 100);
  } else {
    stats.clickThroughRate = 0;
  }
};

// Összes esemény statisztikájának lekérése (admin felülethez)
export const getAllEventStatistics = (): EventStatistics[] => {
  return Object.values(statisticsStore);
};

// Esemény statisztikák exportálása CSV formátumban
export const exportEventStatisticsToCSV = (): string => {
  const headers = ['Esemény azonosító', 'Esemény kód', 'Megtekintések', 'Kattintások', 'Átkattintási arány (%)', 'Utolsó frissítés'];
  const rows = Object.values(statisticsStore).map(stat =>
    [stat.eventId, stat.eventCode, stat.viewCount.toString(), stat.clickCount.toString(), stat.clickThroughRate.toString(), stat.lastUpdated]
  );

  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n');

  return csvContent;
};

// Esemény statisztikák törlése (teszteléshez)
export const clearEventStatistics = (): void => {
  Object.keys(statisticsStore).forEach(key => {
    delete statisticsStore[key];
  });
  console.log('All event statistics have been cleared');
};
